module.exports = __webpack_public_path__ + "static/logo_uwr_hi-c740c48defb3298b8e49aeb6f8746544.png";